import { render } from "./CreateProformaInvoiceView.vue?vue&type=template&id=c36c073c&scoped=true"
import script from "./CreateProformaInvoiceView.vue?vue&type=script&lang=js"
export * from "./CreateProformaInvoiceView.vue?vue&type=script&lang=js"

import "./CreateProformaInvoiceView.vue?vue&type=style&index=0&id=c36c073c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36c073c"]])

export default __exports__